var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.localFilters),function(filter){return _c('b-col',{key:filter.name,attrs:{"cols":_vm.localFieldCols}},[_c(_vm.getFilterComponent(filter.type),{tag:"component",staticClass:"m-b-16",attrs:{"data":filter},on:{"changeValue":function($event){return _vm.onChangeFilter({filter, value: $event})}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }